export const CLIENTS_TEMPLATE_ROUTE = 'clients_list_template.xlsx';

export const SW_PRIVATE_CLIENTS = 'http://www.sovereign-wealth.co.uk';

export const HUBSPOT_ROUTE = 'https://help.digitalwealthsolutions.co.uk';
export const HUBSPOT_ONBOARDING_ISSUES_ROUTE = `${HUBSPOT_ROUTE}/potential-client-onboarding-and-sign-in-issues`;

export const CLIENTS_PAGE_ROUTE = 'https://dws-explained.digitalwealthsolutions.co.uk';
